export default "__VITE_ASSET__CXpYlBqx__"